/** @jsx jsx */
import { __assign, __rest } from "tslib";
import { jsx } from '@emotion/core';
import { N500 } from '@atlaskit/theme/colors';
import { gridSize } from '@atlaskit/theme/constants';
var defaultStyle = {
    alignItems: 'center',
    boxSizing: 'border-box',
    color: N500,
    display: 'flex',
    flexShrink: 0,
    flexDirection: 'column',
    height: '100vh',
    paddingBottom: 2 * gridSize(),
    paddingTop: 3 * gridSize(),
    width: 8 * gridSize(),
};
var sidebarCSS = function () { return defaultStyle; };
var Sidebar = function (_a) {
    var cssFn = _a.cssFn, props = __rest(_a, ["cssFn"]);
    return jsx("div", __assign({ css: cssFn(defaultStyle) }, props));
};
export default {
    component: Sidebar,
    cssFn: sidebarCSS,
};
//# sourceMappingURL=sidebar.js.map